
@if (!config.multiCheck) {
  <div>
    @if (config.isFormArray) {
      <div [formGroup]="group" class="chip-control">
        <div for="" class="default-sub-header text-label"  tabindex="0" [attr.aria-label]="config.groupLabel">{{config.groupLabel | translate}}</div>
        <div [formArrayName]="config.name"  >
          @for (item of configName.controls; track item; let i = $index) {
            <div [formGroup]="item" [ngClass]="config.class">
              @for (option of config.options; track option) {
                <div>
                  <mat-checkbox class="{{ gs.isVersion2 ? '' : 'chip-control__checkbox'}}" formControlName="{{option.id}}">
                    <span class="default-form-field">{{option.value | translate}}</span></mat-checkbox>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (!config.isFormArray) {
        <div [formGroup]="group" class="chip-control {{config.class}}">
          <mat-checkbox class="{{ gs.isVersion2 ? '' : 'chip-control__checkbox'}}" [formControlName]="config.name" >
            @if (innerHTMLdata) {
              <span class="default-form-field" [innerHTML]="config.placeholder"></span>
            }
            @if (!innerHTMLdata) {
              <span class="default-form-field" >{{config.placeholder | translate}}</span>
            }
          </mat-checkbox>
        </div>
      }
    </div>
  }

  @if (config.multiCheck) {
    <div [formGroup]="group" class="mt-3 chip-control {{config.class}}">
      <div for="" class="default-sub-header text-label pb-0">{{config.label | translate}}</div>
      @for (option of config.options; track option) {
        <section class="dynamic-section {{config.class}}" >
          <mat-checkbox class="{{ gs.isVersion2 ? '' : 'chip-control__checkbox'}}" [formControlName]="config.name" [(ngModel)]="config.id" >{{option.value | translate }}</mat-checkbox>
        </section>
      }
    </div>
  }


